import { Skeleton } from "@/components/ui/skeleton";
import {
  PAGE_PADDING_X,
  PAGE_PADDING_Y,
  PAGE_WIDTH_PX,
} from "@/modules/publicQuote/components/PdfPage";

/**
 * Loading placeholder for the Document tab: a US Letter-proportioned page with
 * pulsing content blocks, matching the position the rendered document lands in
 * so the swap from loading to loaded is seamless.
 */
export function QuoteDocumentSkeleton() {
  return (
    <div className="flex justify-center py-8">
      <div
        className="w-full bg-white shadow-lg"
        style={{
          maxWidth: PAGE_WIDTH_PX,
          aspectRatio: "8.5 / 11",
          padding: `${PAGE_PADDING_Y}px ${PAGE_PADDING_X}px`,
        }}
      >
        <div className="flex items-start justify-between">
          <Skeleton className="h-12 w-36" />
          <div className="space-y-2">
            <Skeleton className="h-5 w-40" />
            <Skeleton className="h-3.5 w-28" />
          </div>
        </div>
        <div className="mt-10 space-y-2">
          <Skeleton className="h-3.5 w-3/5" />
          <Skeleton className="h-3.5 w-2/5" />
          <Skeleton className="h-3.5 w-1/2" />
        </div>
        <div className="mt-10 space-y-2">
          <Skeleton className="h-8 w-full" />
          <Skeleton className="h-6 w-full" />
          <Skeleton className="h-6 w-full" />
          <Skeleton className="h-6 w-11/12" />
          <Skeleton className="h-6 w-full" />
        </div>
        <div className="mt-8 flex justify-end">
          <Skeleton className="h-16 w-56" />
        </div>
      </div>
    </div>
  );
}
